import { FeatureListInfo } from "./vo/feature_list_info.model";
import { MediumListInfo } from "./vo/medium_list_info.model";
import { SelectionListInfo } from "./vo/selection-list-info.model";
import { SelectionRequestInfo } from "./vo/selection-request-info.model";
import { TargetListInfo } from "./vo/target_list_info.model";
import { TotallingInfo } from "./vo/totalling-info.model";

/**
 * 表紙特集掲載商品選定（CX）の値を管理するクラス
 *
 * @export KYMW7000Model
 * @class KYMW7000Model
 */
export class KYMW7000Model {

  // 画面バインド用変数
  // 受注コード
  public orderCode: string = <string>"";
  // 企画回
  public catalogId: string = <string>"";
  // 媒体区分
  public mediumType: string = <string>"";
  // 特集コード
  public featureCode: string = <string>"";
  // 特集メモ
  public featureMemo: string = <string>"";
  // 企画担当商品選定済フラグ
  public plannerSelectionFlag: string = <string>"";
  // 承認フロー区分
  public approvalFlowType: string = <string>"";
  
  // 選定商品一覧.全選択チェックボックス
  public selectionListAll: boolean = <boolean>false;
  // 商品部への選定依頼一覧.全選択チェックボックス
  public requestListAll: boolean = <boolean>false;
  // 候補一覧.全選択チェックボックス
  public targetListAll: boolean = <boolean>false;

  // 選定商品一覧.仕入価格.小計
  public selectionTotalCostPrice: number = <number>0;
  // 選定商品一覧.計画数(予測).小計
  public selectionTotalPredictPlanNum: number = <number>0;
  // 選定商品一覧.計画数(修正).小計
  public selectionTotalPlanNum: number = <number>0;
  // 選定商品一覧.計画供給高.小計
  public selectionTotalSupplyBudget: number = <number>0;
  // 選定商品一覧.GPR.小計
  public selectionTotalGpr: number = <number>0;

  // 商品部への選定依頼一覧.仕入価格.小計
  public requestTotalCostPrice: number = <number>0;
  // 商品部への選定依頼一覧.計画数.小計
  public requestTotalPlanNum: number = <number>0;
  // 商品部への選定依頼一覧.計画供給高.小計
  public requestTotalSupplyBudget: number = <number>0;
  // 商品部への選定依頼一覧.GPR.小計
  public requestTotalGpr: number = <number>0;

  // 商品部への選定依頼一覧.計画数.本年計画
  public requestThisYearPlanNum: number = <number>0;
  // 商品部への選定依頼一覧.計画供給高..本年計画
  public requestThisYearSupplyBudget: number = <number>0;
  
  // 候補一覧
  public TargetListInfo: TargetListInfo[] = [];
  // 選定商品一覧
  public SelectionList: SelectionListInfo[] = [];
  // 商品部への選定依頼一覧
  public SelectionRequestInfo: SelectionRequestInfo[] = [];
  // 集計
  public TotallingInfo: TotallingInfo[] = [];
  // 特集一覧
  public FeatureList: FeatureListInfo[] = [];
  // 媒体一覧
  public MediumList: MediumListInfo[] = [];
  // 価格パターン一覧
  public PricePetternList: any[] = [];
}
